import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

const footerLinks = [
  {
    title: 'BaseTao Resources',
    links: [
      { label: 'BaseTao Review', href: mainSiteUrl, external: true },
      { label: 'Shipping Cost Guide', href: mainSiteUrl, external: true },
      { label: 'Coupon & Discounts', href: mainSiteUrl, external: true },
      { label: 'Warehouse Guide', href: mainSiteUrl, external: true },
    ],
  },
  {
    title: 'Quick Links',
    links: [
      { label: 'Home', href: '/', external: false },
      { label: 'Spreadsheet Guide', href: '/basetao-spreadsheet-guide', external: false },
      { label: 'Main Website', href: mainSiteUrl, external: true },
      { label: 'Buy It Now', href: mainSiteUrl, external: true },
    ],
  },
  {
    title: 'Categories',
    links: [
      { label: 'Shoes', href: 'https://kaspreadsheet.com/category-911-Shoes.html', external: true },
      { label: 'Hoodies / Sweaters', href: 'https://kaspreadsheet.com/search-912/name/Shoes.html', external: true },
      { label: 'T-Shirts', href: 'https://kaspreadsheet.com/search-913/name/Shoes.html', external: true },
      { label: 'Jackets', href: 'https://kaspreadsheet.com/search-914/name/Shoes.html', external: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-10">
        {/* Top row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link
              to="/"
              className="font-heading text-xl md:text-2xl font-bold text-background-50 hover:text-primary-300 transition-colors"
            >
              BaseTao<span className="text-primary-400">Sheet</span>
            </Link>
            <p className="text-sm text-background-50/50 mt-3 leading-relaxed max-w-xs">
              The most complete BaseTao Spreadsheet research platform — your trusted resource for reviews, shipping, coupons, and buying guides.
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-3 mt-5">
              {['twitter', 'reddit', 'pinterest', 'medium'].map((icon) => (
                <a
                  key={icon}
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500/30 transition-colors cursor-pointer"
                  aria-label={icon}
                >
                  <i className={`ri-${icon}-line text-sm text-background-50/60`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-semibold text-sm text-background-50 mb-4 uppercase tracking-wider">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((link) =>
                  link.external ? (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-background-50/50 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-background-50/50 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 border-t border-background-50/10 gap-4">
          <p className="text-xs text-background-50/40 text-center sm:text-left">
            &copy; {new Date().getFullYear()} BaseTao Spreadsheet Hub. All rights reserved. BaseTao is a trademark of its respective owners.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              Privacy Policy
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-background-50/40 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}